// import Vue from 'vue'
import axios from 'axios'
// import store from '@/store'
// import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import isSingapore from '../setting'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

const err = (error) => {
  window.location.href = '/'
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const AUTH =
    'eyJvIjoic2FkYSIsInR5cCI6IkpXVCIsImFsZyI6IkhTMjU2In0.eyJpYXQiOjE2MTg1NjcwNDEsImhhc2hfaWQiOiJXMGdkWnJOOSJ9.mO3Plk8Cafig7ZWbGZ-ac_G3nUO2PEiHQMRPhcwa7w4'
  let {headers, url} = config
  const isElect = url.includes('/elec/')
  if (isElect) url = url.slice(5)
  const token = sessionStorage.getItem('authorization')
  const decoderToken = decodeURIComponent(token)
  const obj = {Authorization: decoderToken, AUTH}
  // eslint-disable-next-line no-unused-vars
  url = isSingapore ? '' : `${isElect ? '//api.e.v1.i-sada.net' : '//api.crane.v3.i-sada.net'}${url}`
  const newHeaders = {...headers, ...obj}
  return isSingapore ? {...config, ...{headers: newHeaders}} : {...config, ...{headers: newHeaders, url, mode: 'cors'}}
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  const {url} = response.config
  const login = url.includes('/login')
  if (login) {
    const token = response.headers['authorization']
    sessionStorage.setItem('authorization', encodeURIComponent(token))
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js